import { createAction, createReducer } from '@reduxjs/toolkit';

import { useAppDispatch } from '@shared/hooks';

const toggle = createAction('support/toggle');

const initialState = { isOpen: false };

export const supportReducer = createReducer(initialState, (builder) => {
	builder.addCase(toggle, (state) => {
		state.isOpen = !state.isOpen;
	});
});

export const useSupportModal = () => {
	const dispatch = useAppDispatch();

	const toggleSupport = () => dispatch(toggle());
	return { toggleSupport };
};
